import type { ThemeConfig } from "antd";

export const notificationsTableTheme: ThemeConfig = {
  components: {
    Typography: {
      titleMarginBottom: 0,
    },
    Layout: {
      colorBgHeader: "#fff",
    },
    Table: {
      headerBg: "#fff",
      headerColor: "#000",
      bodySortBg: "#fff",
      rowHoverBg: "#fafafa",
      borderColor: "#f0f0f0",
      footerBg: "#fff",
    },
  },
};
